﻿export const textLink = 'no-underline underline-hover blue';
export const textLinkNoHover = 'no-underline blue';
